// extracted by mini-css-extract-plugin
export default {"container":"animated_div-module___container___bf49f3b5","root":"animated_div-module___root___f0423165"};